import React, { useState, useCallback } from 'react'
import { StyledText, Toast } from '@clickcease/cc-client-components-lib'
import {
  StyledPendingInvitations,
  StyledPendingInvitationsTitleButton,
  StyledPendingInvitationsToastWrapper,
} from './PendingInvitations.styled'
import { useTranslation } from 'react-i18next'
import { useAcceptPendingInvitation } from '../../api/useAcceptPendingInvitation'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { InvitationAcceptanceModal } from './components/InvitationAcceptanceModal'

interface PendingInvitationsProps {
  pendingInvitations: Array<{
    accountId: number
    accountName: string
    accepted: boolean
  }>
  onInviteAccepted?: () => void
}

export const PendingInvitations: React.FC<PendingInvitationsProps> = ({
  pendingInvitations,
  onInviteAccepted,
}) => {
  const { t } = useTranslation('pricing')
  const { userId } = useUserStore()
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false)

  const { mutate: acceptPendingInvitation } = useAcceptPendingInvitation({
    onSuccess: () => {
      onInviteAccepted?.()
    },
  })

  const handleAcceptInvite = useCallback(
    (selectedInvite: number[]) => {
      acceptPendingInvitation({ userId, accounts: selectedInvite })
    },
    [userId, acceptPendingInvitation]
  )

  const handleCloseAcceptModal = useCallback(() => {
    setIsAcceptModalOpen(false)
  }, [])

  const handleOpenAcceptModal = useCallback(() => {
    setIsAcceptModalOpen(true)
  }, [])

  return (
    <StyledPendingInvitations>
      <StyledPendingInvitationsToastWrapper>
        <Toast type="warning">
          <StyledPendingInvitationsTitleButton onClick={handleOpenAcceptModal}>
            <StyledText>
              {pendingInvitations.length === 1
                ? t('pending_invitations.single_pending_invite')
                : t('pending_invitations.multiple_pending_invites')}
            </StyledText>
          </StyledPendingInvitationsTitleButton>
        </Toast>
      </StyledPendingInvitationsToastWrapper>

      <InvitationAcceptanceModal
        pendingInvitations={pendingInvitations}
        onAccept={handleAcceptInvite}
        isOpen={isAcceptModalOpen}
        onClose={handleCloseAcceptModal}
      />
    </StyledPendingInvitations>
  )
}
